import moment from 'moment';
import { LitEntity, SirenActionMixin, html, css } from '../../utility/lit-entity';

class BinLevels extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this._defaultStart = moment().startOf('day').utc().subtract(3, 'week').format();
    this._defaultEnd = moment().utc().format();
  }

  static get styles() {
    return css`
      :host {
        display: none;
      }
    `;
  }

  static get properties() {
    return {
      start: { type: String, reflect: true },
      end: { type: String, reflect: true },
    };
  }

  render() {
    return html``;
  }

  async updated() {
    if (!this.entity) {
      return;
    }

    await this.updateComplete;
    this._setHrefWithStartEnd();
  }

  _entityChanged(entity) {
    super._entityChanged(entity);

    // Only use defaults if no start/end provided by parent component
    this.start = this.start || this._defaultStart;
    this.end = this.end || this._defaultEnd;
  }

  _setHrefWithStartEnd() {
    if (!this.entity) {
      return;
    }

    const action = this.entity.getActionByName('custom-date-range');
    const fields = this.getActionFields(action);
    if (fields.get('startDate') === this.start && fields.get('endDate') === this.end) {
      return;
    }

    if (!this.start && !this.end) {
      return;
    }

    this.start && fields.set('startDate', this.start);
    this.end && fields.set('endDate', this.end);
    this.href = this.parseAction(action, fields).url.href;
  }
}

window.customElements.define('bin-levels', BinLevels);
